import React from "react";
import styled from "styled-components";
import colors from "../../utils/constants/COLORS";

/**
 * Render a pill-style badge that can be toggled on/off.
 *
 * Props:
 * - label: string to display inside the badge
 * - selected: boolean state of the badge
 * - onClick: handler invoked when the badge is clicked
 * - disabled: optional boolean to prevent interaction
 */
const SelectableBadge = ({ label, selected, onClick, disabled = false }) => {
  return (
    <BadgeContainer
      selected={selected}
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
    >
      {label}
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  user-select: none;

  background-color: ${(props) =>
    props.selected ? "#2c6ecb" : "#F1F1F3"};
  color: ${(props) => (props.selected ? "#FFFFFF" : colors.primary)};
  border: 1px solid
    ${(props) => (props.selected ? "#2c6ecb" : "#CCC")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  transition: background-color 0.2s, color 0.2s, border-color 0.2s;

  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? props.selected
          ? "#2c6ecb"
          : "#F1F1F3"
        : props.selected
        ? "#2c6ecb"
        : "#E0E0E5"};
  }
`;

export default SelectableBadge;
